export const apiEndPoints = {
    login: "login",
    notification: "notification",
    verify: "verify",
    reset_password: "reset-password",
    logout: "logout",
    changePassword: "change-password",
    apikeys:"api-keys",
    companies:"companies",
    users: "users",
    generateToken: "generate-token",
    commercialRental:"commercial-rental",
    apartmentSaleAvm : "apartment-sale-transaction-growth-rate-avm",
    userResource: "user/resource",
    avmRental:"avm-rental",
    avmData:"avm-data",
    avmApi:"avm",
    nearbyData:"nearby-data",
    officeProperty: "office-property-details",
    buildings: "buildings",
    floors: "floors",
    units: "units",
    transactions: "transactions",
    place:"place",
    propertySearch : 'property-search',
    nearby:"nearby",
    avmCalculator:"avm-calculator"
}
